__turbopack_context__.v({
  "card": "CtaSection-module__pqQDQG__card",
  "cards": "CtaSection-module__pqQDQG__cards",
  "content": "CtaSection-module__pqQDQG__content",
  "ctaSectionContainer": "CtaSection-module__pqQDQG__ctaSectionContainer",
  "description": "CtaSection-module__pqQDQG__description",
  "footer": "CtaSection-module__pqQDQG__footer",
  "title": "CtaSection-module__pqQDQG__title",
});
